export const appName = 'team-calendar';
